<template>
  <Layer @close="$emit('close')" title="Edit Stock" width="36rem">
    <div class="edit-stock-layer">
      <ProductShelfTeaser :product="product" :shelfSpaceId="shelfSpaceId" :amount="stock.amount" />
      <div style="display: flex; justify-content: space-between;">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-primary"
            :class="{ active: mode === 'add-stock' }"
            v-blur-on-click
            @click="openAddAmount"
          >
            Add
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            :class="{ active: mode === 'edit-stock' }"
            v-blur-on-click
            @click="openEditAmount"
          >
            Edit
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            :class="{ active: mode === 'restore' }"
            v-blur-on-click
            @click="openRestore"
          >
            Move
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            :class="{ active: mode === 'delete-stock' }"
            v-blur-on-click
            @click="mode = 'delete-stock'"
          >
            Delete
          </button>
        </div>
        <div class="btn-group" role="group">
          <router-link
            tag="button"
            :to="{ name: 'shelf', params: { shelfSpaceId } }"
            type="button"
            class="btn btn-outline-primary"
            v-if="openLink === 'shelf'"
            >Open Shelf</router-link
          >
          <router-link
            tag="button"
            :to="{ name: 'product', params: { productId } }"
            type="button"
            class="btn btn-outline-primary"
            v-if="openLink === 'product'"
            >Open Product</router-link
          >
        </div>
      </div>
      <form v-if="mode === 'add-stock'" @submit.prevent="saveNewAmount">
        <h2 class="h4 mt-4 mb-2">Add Amount</h2>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text white-bg">{{ stock.amount }} +</span>
          </div>
          <input
            type="text"
            class="form-control shadow-none"
            v-model="addedStock"
            autofocus
            inputmode="numeric"
            ref="addStockInput"
          />
          <div class="input-group-append">
            <span class="input-group-text white-bg">= {{ newAmount }}</span>
            <button class="btn btn-success" type="submit">Restore</button>
          </div>
        </div>
      </form>
      <form v-if="mode === 'edit-stock'" @submit.prevent="saveNewAmount">
        <h2 class="h4 mt-4 mb-2">Edit Amount</h2>
        <div class="input-group">
          <input
            type="text"
            class="form-control shadow-none"
            v-model="editedStock"
            :placeholder="stock.amount"
            autofocus
            inputmode="numeric"
            ref="editStockInput"
          />
          <div class="input-group-append">
            <button class="btn btn-success" type="submit">Save Amount</button>
          </div>
        </div>
      </form>
      <form v-if="mode === 'restore'" @submit.prevent="saveRestore">
        <h2 class="h4 mt-4 mb-2">Move to Shelf</h2>
        <div class="input-group">
          <input
            type="text"
            class="form-control shadow-none"
            v-model="restoreShelf"
            placeholder="Scan shelf"
            autofocus
            ref="restoreInput"
          />
          <div class="input-group-append">
            <button class="btn btn-success" type="submit">Move</button>
          </div>
        </div>
      </form>
      <form v-if="mode === 'delete-stock'" @submit.prevent="deleteStock">
        <h2 class="h4 mt-4 mb-2">Delete Stock</h2>
        <div class="input-group">
          <span class="input-group-text white-bg">Are you sure you want to delete the stock?</span>
          <div class="input-group-append">
            <button class="btn btn-danger" type="submit">Delete</button>
          </div>
        </div>
      </form>
    </div>
  </Layer>
</template>

<script>
import ProductShelfTeaser from '@/components/ProductShelfTeaser'
import Warehouse from '@/controllers/Warehouse'
import Layer from '@/shared/Layer'
import { db } from '@/shared/firebase'

export default {
  components: { Layer, ProductShelfTeaser },
  props: {
    product: {
      type: Object
    },
    productId: {
      type: String
    },
    shelfSpaceId: {
      type: String
    },
    openLink: {
      type: String
    }
  },
  data() {
    return {
      mode: null,
      addedStock: null,
      editedStock: null,
      restoreShelf: null
    }
  },
  computed: {
    shelfId() {
      return this.shelfSpaceId.split('-')[0]
    },
    spaceId() {
      return this.shelfSpaceId.split('-')[1]
    },
    shelf() {
      return _.find(this.$store.state.shelves, { id: this.shelfId })
    },
    space() {
      return this.shelf.spaces[this.spaceId]
    },
    itemIndex() {
      return _.findIndex(this.space.items, { productId: this.productId })
    },
    stock() {
      return _.find(this.space.items, { productId: this.product.id })
    },
    newAmount() {
      return this.mode === 'add-stock'
        ? parseFloat(this.stock.amount) + (this.addedStock ? parseFloat(this.addedStock) : 0)
        : this.editedStock
    }
  },
  methods: {
    openAddAmount() {
      this.mode = 'add-stock'
      setTimeout(() => {
        this.$refs.addStockInput.focus()
      }, 100)
    },
    openEditAmount() {
      this.mode = 'edit-stock'
      setTimeout(() => {
        this.$refs.editStockInput.focus()
      }, 100)
    },
    openRestore() {
      this.mode = 'restore'
      setTimeout(() => {
        this.$refs.restoreInput.focus()
      }, 100)
    },
    saveNewAmount() {
      if (!isNaN(this.newAmount)) {
        const { shelfId, spaceId, productId } = this
        Warehouse.editAmount({
          shelfId,
          spaceId,
          productId,
          newAmount: parseFloat(this.newAmount)
        })
        this.$emit('close')
      } else {
        alert('The amount needs to be a valid number')
      }
    },
    saveRestore() {
      const fromId = this.shelfSpaceId
      // legacy lösung
      const oldShelfId = /^[A-Z][0-9][0-9][0-9]$/.test(this.restoreShelf)
      if (oldShelfId) {
        this.restoreShelf = `SH-${this.restoreShelf.substr(0, 1)}0${this.restoreShelf.substr(
          1,
          1
        )}-${this.restoreShelf.substr(2, 2)}`
      }
      const toId = this.restoreShelf.replace('SH-', '')

      const oldShelf = _.cloneDeep(
        this.$store.state.shelves.find(shelf => shelf.id === fromId.split('-')[0])?.spaces[fromId.split('-')[1]]
      )
      const oldShelfIndex = _.findIndex(oldShelf.items, { productId: this.productId })
      const entry = oldShelf.items.splice(oldShelfIndex, 1)

      const newShelf = _.cloneDeep(
        this.$store.state.shelves.find(shelf => shelf.id === toId.split('-')[0])?.spaces[toId.split('-')[1]]
      )
      if (!newShelf) return alert(`Couldn't find shelf ${toId}`)
      const itemIndex = _.findIndex(newShelf.items, { productId: this.productId })
      if (itemIndex !== -1) {
        const item = newShelf.items[itemIndex]
        item.amount += entry[0].amount
        newShelf.items[itemIndex] = item
      } else {
        entry[0].shelfSpaceId = toId
        newShelf.items.push(entry[0])
      }

      const confirm = window.confirm(`Are you sure you want to move the stock to shelf ${toId}?`)
      if (!confirm) return

      const batch = db.batch()

      batch.update(db.doc(`private/warehouse/shelves/${fromId.split('-')[0]}`), {
        [`spaces.${fromId.split('-')[1]}.items`]: oldShelf.items
      })

      batch.update(db.doc(`private/warehouse/shelves/${toId.split('-')[0]}`), {
        [`spaces.${toId.split('-')[1]}.items`]: newShelf.items
      })

      batch.commit()

      this.$emit('close')
    },
    deleteStock() {
      const { shelfId, spaceId, productId } = this
      Warehouse.deleteStock({
        shelfId,
        spaceId,
        productId
      })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-stock-layer {
  padding: 2rem;
}

.white-bg {
  background: #fff;
}
</style>
